import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-xl">
                <i className="ri-tools-line text-2xl text-white"></i>
              </div>
              <span className="text-2xl font-bold">MTA Planner Pro</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              AI-powered quoting and job management software built specifically for Australian tradies. Save time, win more jobs, get paid faster.
            </p>
            
            {/* Trust Badges */}
            <div className="space-y-3 mb-6">
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-verified-badge-fill text-teal-500"></i>
                <span>ABN: 51 824 753 916</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-shield-check-fill text-teal-500"></i>
                <span>ATO Compliant • GST Ready</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-star-fill text-yellow-400"></i>
                <span>4.9★ Rating • 2,400+ Active Tradies</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Solutions Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Solutions</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/sole-trader" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Sole Trader
                </Link>
              </li>
              <li>
                <Link to="/job-marketplace" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Job Marketplace
                </Link>
              </li>
              <li>
                <Link to="/invoice" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  AI Invoicing
                </Link>
              </li>
              <li>
                <Link to="/gps-tracking" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  GPS Tracking
                </Link>
              </li>
            </ul>
          </div>

          {/* Industries Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Industries</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/industries/plumbing" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Plumbing
                </Link>
              </li>
              <li>
                <Link to="/industries/electrical" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Electrical
                </Link>
              </li>
              <li>
                <Link to="/industries/carpentry" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Carpentry
                </Link>
              </li>
              <li>
                <Link to="/industries/hvac" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  HVAC
                </Link>
              </li>
              <li>
                <Link to="/industries/painting" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Painting
                </Link>
              </li>
              <li>
                <Link to="/industries/roofing" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Roofing
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="font-bold text-lg mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/airtasker-service" className="text-gray-400 hover:text-white transition-colors">
                  Professional Quote Service
                </Link>
              </li>
              <li>
                <Link to="/demo" className="text-gray-400 hover:text-white transition-colors">
                  Live Demo
                </Link>
              </li>
              <li>
                <Link to="/invoice-demo" className="text-gray-400 hover:text-white transition-colors">
                  Invoice Demo
                </Link>
              </li>
              <li>
                <Link to="/help-center" className="text-gray-400 hover:text-white transition-colors">
                  Help Center
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 MTA Planner Pro. All rights reserved. Built for Australian Tradies.
            </p>
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-secure-payment-line text-teal-500"></i>
                <span>Secure payments by</span>
                <span className="font-semibold text-white">Stripe</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-lock-2-line text-teal-500"></i>
                <span>256-bit SSL</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}